import { useSelector } from "react-redux";
import HashtagIcon from "assets/icons/Hashtag";
import { useRef } from "react";
import { MiladiToJalali } from "helpers/dataFormat";
import { Typography } from "@mui/material";
import { getPersianMotnh } from "helpers/helper";
import { formatPrice } from "helpers";
export default function useSalaryPrint(props?: { salary?: any }) {
    const store = useSelector((state: any) => state);
    const salary = props?.salary ? props?.salary : undefined
    const business = store.businessReducer.business.business;
    const contentRef = useRef<any>(null);
    let benefitsSum = 0;
    let deductionsSum = 0;
    let content = <></>;
    if (salary) {
        salary?.Accounting_Items.map((item: any) => {
            if (item.isCreditor === false) {
                benefitsSum += item.amount
            }
            else {
                deductionsSum += item.amount
            }
        })

        content = (<div ref={contentRef} dir="rtl" className="flex flex-col px-6">
            {

                <div className="flex flex-col gap-4 mt-5 mb-10">
                    <div className="flex items-center place-content-center ">
                        <Typography variant="body1" className="font-bold  text-center mb-4">
                            {business?.legalName || business?.nickName}
                        </Typography>
                    </div>
                    <div className="flex justify-end">
                        <div className="flex gap-2 items-center">
                            <HashtagIcon />
                            <span className="font-bold">تاریخ:</span>
                            <span>{`${getPersianMotnh(salary?.SalaryAccountings[0].month)}/${salary?.SalaryAccountings[0].year}`}</span>
                        </div>
                    </div>
                    <div className="flex flex-row gap-10 w-full justify-between">
                        <div className="flex gap-2 items-center">
                            <HashtagIcon />
                            <span className="font-bold">کد کارمند:</span>
                            <span>{salary?.person.accountingCode}</span>
                        </div>
                        <div className="flex gap-2 items-center">
                            <HashtagIcon />
                            <span className="font-bold">نام و نام خانوادگی:</span>
                            <span>{salary?.person.nickName}</span>
                        </div>
                        <div className="flex gap-2 items-center">
                            <HashtagIcon />
                            <span className="font-bold">شماره ملی:</span>
                            <span>{salary?.person.nationalId}</span>
                        </div>
                    </div>
                    <table className="w-full text-sm text-center  border border-black mt-5">
                        <thead>
                            <tr className="border border-black">
                                {/* <td className="border-l font-bold">
                                    کارکرد ماهانه
                                </td> */}
                                <td colSpan={2} className="border-l border-black font-bold p-2">
                                    حقوق و  دستمزد (ریال)
                                </td>
                                <td colSpan={2} className="font-bold border-black p-2">
                                    کسورات (ریال)
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border-l border-black align-baseline p-2">
                                    {salary?.Accounting_Items.map((item: any) => {
                                        if (!item.isCreditor) {
                                            return (
                                                <p key={item.id} className="text-right">
                                                    {item.Account_Type.title}
                                                </p>
                                            );
                                        }
                                        return null;
                                    })}

                                </td>
                                <td className="border-l border-black align-baseline p-2">
                                    {salary?.Accounting_Items.map((item: any) => {
                                        if (!item.isCreditor) {
                                            return (
                                                <p key={item.id} className="text-left">
                                                    {formatPrice(item.amount)}
                                                </p>
                                            );
                                        }
                                        return null;
                                    })}
                                </td>
                                <td className="border-l border-black align-baseline p-2">

                                    {salary?.Accounting_Items.map((item: any) => {
                                        if (item.isCreditor) {
                                            return (
                                                <p key={item.id} className="text-right">
                                                    {item.Account_Type.title}
                                                </p>
                                            );
                                        }
                                        return null;
                                    })}
                                </td>
                                <td className="align-baseline p-2">

                                    {salary?.Accounting_Items.map((item: any) => {
                                        if (item.isCreditor) {
                                            return (
                                                <p key={item.id} className="text-left">
                                                    {formatPrice(item.amount)}
                                                </p>
                                            );
                                        }
                                        return null;
                                    })}
                                </td>


                            </tr>
                            <tr>
                                <td colSpan={2} className="border-t border-l border-black p-2">
                                    <p className=" text-center font-bold">جمع حقوق دستمزد: {formatPrice(benefitsSum)}</p>

                                </td>
                                <td colSpan={2} className="border-t border-black p-2 text-center">
                                    <p className=" text-center font-bold">جمع کسورات: {formatPrice(deductionsSum)}</p>

                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4} className="border-t border-l border-black p-2">
                                    <p className=" text-center font-bold"> خالص پرداختی: {formatPrice(salary.pureReceived)} ریال</p>

                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </div>
        )
    }
    return { content, contentRef };
}
